import reduce from 'image-blob-reduce';
export class PicturesService {
    constructor(uuidGenerator, serviceUrl) {
        this.uuidGenerator = uuidGenerator;
        this.serviceUrl = serviceUrl;
        this.picturesEndpoint = new URL('picture', this.serviceUrl).href;
    }
    async uploadPicture(file, max = 500) {
        const blob = await reduce().toBlob(file, { max });
        const pictureId = this.uuidGenerator.createUuid();
        const formData = new FormData();
        formData.set('pictureId', pictureId);
        formData.set('file', blob);
        formData.set('type', file.type);
        const response = await fetch(this.picturesEndpoint, {
            method: 'POST',
            body: formData,
        });
        if (response.ok) {
            return pictureId;
        }
        const content = await response.json();
        if (content.errorName === 'file_too_big') {
            const error = new Error('El archivo subido es demasiado grande.');
            error.name = 'file_too_big';
            throw error;
        }
        throw new Error('Ha ocurrido un error al enviar la imagen.');
    }
    async deletePicture(pictureId) {
        const response = await fetch(`${this.picturesEndpoint}/${pictureId}`, {
            method: 'DELETE',
        });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al eliminar la imagen.');
        }
    }
}
